import React from 'react';

import cs from 'classnames';

import Button from 'components/shared/Button/Button';
import AGChart from 'components/shared/AGChart/AGChart';
import ErrorMessage from 'components/shared/ErrorMessage/ErrorMessage';
import { CHART_COLORS, CHART_INK } from 'components/shared/AGChart/lib/constants';
import ErrorBoundary, { withErrorBoundary } from 'components/shared/Error/Boundary';

const StepsChart = ({
  chartData,
  title,
  description,
  roundedBottom,
  innerText,
  showButton,
  buttonText,
  handleClick
}) => {
  const options = {
    width: 100,
    height: 100,
    series: [
      {
        data: chartData,
        type: 'donut',
        angleKey: 'value',
        fills: [CHART_COLORS[0], CHART_INK.surface],
        innerRadiusRatio: 0.7,
        innerLabels: [{ text: innerText, color: CHART_INK.value }],
        tooltip: {
          enabled: false
        }
      }
    ]
  };
  return (
    <ErrorBoundary FallbackComponent={ErrorMessage}>
      <div
        className={cs(
          'grid w-full grid-cols-6 items-center justify-between !gap-2 bg-gradient-to-t from-[#CCF1FF] to-[#E6F8FF] ',
          roundedBottom && 'rounded-b-[16px]',
          !roundedBottom ? 'py-0 pl-2 pr-1' : 'py-2 pr-2'
        )}>
        <div
          className={cs(
            'col-span-5 flex items-center !gap-2 pr-4',
            roundedBottom || (!showButton && 'col-span-6')
          )}>
          <AGChart options={options} />
          <div className="grid gap-1">
            <p className="text-sm font-500 text-primary-900">{title}</p>
            <p className="text-[12px] font-400 text-primary-900">{description}</p>
          </div>
        </div>
        {showButton && (
          <div className="col-span-1">
            <Button text={buttonText} onClick={handleClick} size="medium" />
          </div>
        )}
      </div>
    </ErrorBoundary>
  );
};

export default withErrorBoundary(StepsChart);
